/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Utilities from '../../global/Utilities';
import './reports.css';

class BulkUploadSummary extends Component {
    
    render() {
        const { item } = this.props;
        Utilities.LogPrint('BulkUploadSummary', item);
        if (item !== undefined) {
            return (
                <tr>
                    <td>{item.fdo_name}</td>
                    <td>{item.individual_visit_count}</td>
                    <td>{item.sample_distribution_count}</td>
                    <td>{item.group_meeting_count}</td>
                    <td>{item.Sample_to_sale_count}</td>
                    <td>{item.total}</td>
                </tr>
            );
        } else {
            return null;
        }
    }
}

export default withRouter(BulkUploadSummary)